import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allPosList, findMerchant, signUpMerchant } from "../redux/auth/Action";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { firebaseAuth } from "../utils/firebase-config";

const inputClass =
  "w-full border border-gray-200 px-4 py-2.5 rounded-lg text-sm text-gray-900 placeholder-gray-400 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200";

const labelClass = "block text-sm font-medium text-gray-700 mb-1.5";

const errorClass = "text-red-500 text-xs mt-1";

const Signup = ({ changeToLogin, setIsLogin }) => {
  // const [isLogin, setIsLogin] = useState(true);
  const [token, setToken] = useState();
  const [merchant, setMerchant] = useState();
  const [accessTokenError, setAccessTokenError] = useState(true);
  const [pos, setPos] = useState();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    pos: "",
    ABN: "",
    accessToken: "",
    businessName: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = `${key} is required`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const posList = useSelector((e) => {
    return e.reducer.posList;
  });
  function getList(e) {
    let { name, value } = e;
    setFormData({
      ...formData,
      ...merchant,
      [name]: value,
      posId: pos?.id,
    });
  }

  function submitForm(event) {
    validateForm();
    event.preventDefault();
    if (!errors && formData && merchant) {
      handleSignUp();
    }
  }

  const handleSignUp = async () => {
    try {
      const { email, password } = formData;
      let user = await createUserWithEmailAndPassword(
        firebaseAuth,
        email,
        password
      );
      const idToken = await user._tokenResponse.idToken;
      const merchant = await signUpMerchant(formData, dispatch, idToken);
      if (merchant && user) {
        localStorage.setItem("userId", user._tokenResponse.localId);
        localStorage.setItem("email", email);
        localStorage.setItem("Token", idToken);
        setIsLogin(true);
        alert("User signed up successfully");
      }
    } catch (error) {
      alert(error);
    }
  };

  async function getMerchant(key) {
    setToken(key);
    if (!pos) {
      return;
    }
    if (!key) {
      setAccessTokenError("");
      return;
    }
    setAccessTokenError("");
    try {
      const merchantData = await findMerchant(key);
      if (merchantData) {
        setMerchant({ ...merchantData });
        setTimeout(() => {
          setToken(true);
        }, 2000);
      }
    } catch (e) {
      setAccessTokenError("invalid access token");
      setMerchant("");
      setToken(false);
    }
  }

  useEffect(() => {
    allPosList(dispatch);
    setErrors("");
  }, []);

  useEffect(() => {
    if (token && pos) {
      getMerchant(token);
    }
  }, [pos]);

  return (
    <div className="bg-white rounded-2xl shadow-card-lg px-10 py-10 w-full my-6">
      <h1 className="font-bold text-2xl text-gray-900 mb-1">Sign Up</h1>
      <p className="text-sm text-gray-500 mb-8">Create your merchant account to get started.</p>

      <form className="flex flex-col gap-4 w-full">
        {/* Owner Name */}
        <div>
          <label className={labelClass}>Owner Name</label>
          <input
            type="text"
            placeholder="Enter your full name"
            className={inputClass}
            autoComplete="off"
            name="name"
            onChange={(e) => getList(e.target)}
            maxLength="30"
          />
          {errors.name && <p className={errorClass}>{errors.name}</p>}
        </div>

        {/* Email */}
        <div>
          <label className={labelClass}>Email Address</label>
          <input
            type="email"
            placeholder="you@example.com"
            className={inputClass}
            autoComplete="off"
            name="email"
            onChange={(e) => getList(e.target)}
            maxLength="30"
          />
          {errors.email && <p className={errorClass}>{errors.email}</p>}
        </div>

        {/* POS */}
        <div>
          <label className={labelClass}>Select Your POS</label>
          <select
            className={`${inputClass} appearance-none cursor-pointer`}
            autoComplete="off"
            name="pos"
            onChange={(e) => (
              setPos(posList[e.target.value]), getList(e.target)
            )}
          >
            <option value="" disabled selected>
              Select Your POS
            </option>
            {posList.map((pos, i) => {
              return (
                <option value={i} key={i}>
                  {pos.name}
                </option>
              );
            })}
          </select>
          {token && !pos ? (
            <p className={errorClass}>Please select your POS</p>
          ) : (
            errors.pos && <p className={errorClass}>{errors.pos}</p>
          )}
        </div>

        {/* ABN */}
        <div>
          <label className={labelClass}>ABN</label>
          <input
            type="text"
            placeholder="Enter your ABN"
            className={inputClass}
            autoComplete="off"
            name="ABN"
            inputMode="numeric"
            pattern="\d*"
            onChange={(e) => getList(e.target)}
            maxLength="11"
          />
          {errors.ABN && <p className={errorClass}>{errors.ABN}</p>}
        </div>

        {/* Access Token */}
        <div>
          <label className={labelClass}>
            Access Token&nbsp;
            <a
              href="/signup-instruction"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-500 text-xs font-normal hover:underline"
            >
              ( find your access key{" "}
              <i className="fa-solid fa-key text-[0.6rem]"></i> )
            </a>
          </label>
          <input
            type="text"
            placeholder="Enter your Square access token"
            className={inputClass}
            autoComplete="off"
            name="accessToken"
            onChange={(e) => (
              getMerchant(e.target.value),
              getList(e.target),
              setToken(e.target.value)
            )}
          />
          {!merchant ? (
            <p className={errorClass}>{accessTokenError}</p>
          ) : (
            errors.accessToken && <p className={errorClass}>{errors.accessToken}</p>
          )}
        </div>

        {/* Business Name (conditional) */}
        {token && merchant && (
          <div>
            <label className={labelClass}>Business Name</label>
            <input
              type="text"
              placeholder="Your business name"
              className={`${inputClass} bg-gray-50 text-gray-500 cursor-not-allowed`}
              autoComplete="off"
              name="businessName"
              value={merchant?.business_name}
              onChange={(e) => getList(e.target)}
              disabled={true}
            />
          </div>
        )}

        {/* Password */}
        <div>
          <label className={labelClass}>Password</label>
          <input
            type="password"
            placeholder="Create a password"
            className={inputClass}
            autoComplete="off"
            name="password"
            onChange={(e) => getList(e.target)}
            maxLength="16"
          />
          {errors.password && <p className={errorClass}>{errors.password}</p>}
        </div>

        <button
          type="button"
          className="bg-[#4070f4] hover:bg-[#2d5ce8] active:bg-[#1a47d1] text-white font-semibold py-2.5 rounded-lg w-full transition-colors duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#4070f4] focus:ring-offset-2 mt-2"
          onClick={submitForm}
        >
          Create Account
        </button>
      </form>

      <p className="mt-6 text-sm text-gray-500 text-center">
        Already have an account?{" "}
        <span
          className="text-primary-500 font-semibold cursor-pointer hover:underline"
          onClick={() => changeToLogin()}
        >
          Sign In
        </span>
      </p>
    </div>
  );
};

export default Signup;
